import React from 'react'

import SupportListWrapper from 'core/page/SupportListWrapper'
import { loadDefaultRevenueGroup } from '../state/actions'
import { Link } from 'react-router-dom'
import { IExtendedColumn } from '@cbgms/components/grid/Types'
import { IDefaultRevenueGroup } from '@cbgms/api/modules/support'

export const mapLinkToColumn = (columns: IExtendedColumn[]) => {
  return columns.map(col => ({
    ...col,
    action:
      col.key === 'DefaultRevenueGroup.CompanyName'
        ? ({ data }: { data: { DefaultRevenueGroup: IDefaultRevenueGroup } }) => (
            <Link to={`/companies/edit/${data.DefaultRevenueGroup.CompanyUUID}`}>{data.DefaultRevenueGroup.CompanyName}</Link>
          )
        : col.action
  }))
}
const DefaultRevenueList: React.FC = () => (
  <div>
    <SupportListWrapper
      scope='default-revenue-group'
      type='list'
      onColumnMap={mapLinkToColumn}
      skipDryRun
      loadAction={loadDefaultRevenueGroup}
      translationKey='default-revenue-groups'
    />
  </div>
)

export default DefaultRevenueList
